module.exports = __webpack_public_path__ + "static/background_image-a36cf948621cd2967059e6aace41b35c.jpg";